import { render, staticRenderFns } from "./result-summary.vue?vue&type=template&id=695d0fdb&scoped=true&"
import script from "./result-summary.vue?vue&type=script&lang=js&"
export * from "./result-summary.vue?vue&type=script&lang=js&"
import style0 from "./result-summary.vue?vue&type=style&index=0&id=695d0fdb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695d0fdb",
  null
  
)

export default component.exports